import { formatYearMonthFilterItem } from './year-month-labels';

export const YEAR_MONTH_COMBO_COMPONENT = 'comboBoxYearMonth';

function getDashboardItemName(args) {
    const item = args.getDashboardItem?.() ?? args.dashboardItem;
    return item?.componentName?.() ?? item?.name?.() ?? item?.name;
}

/**
 * Shows Norwegian month names in the month combo while keeping yyyy-MM filter keys.
 */
export function onYearMonthComboWidgetOptionsPrepared(args) {
    if (getDashboardItemName(args) !== YEAR_MONTH_COMBO_COMPONENT) {
        return;
    }

    const options = args.options;
    if (!options) {
        return;
    }

    options.displayExpr = (item) => formatYearMonthFilterItem(item);

    options.itemTemplate = (item, _index, element) => {
        const node = element?.get?.(0) ?? element;
        if (!node) {
            return;
        }
        node.textContent = formatYearMonthFilterItem(item);
    };
}
